import {
	MimaButton,
	MimaText,
	Modal,
} from '../../components';
import { customerStore } from '../../stores';
import React from 'react';

const DeleteCustomer = ({ closeModal, goBack, onDelete, loading }) => {

  const { selectedCustomer } = customerStore

	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			<MimaText variant="subtitleBold" align="center" mb={3}>
				Delete Customer
			</MimaText>

      <MimaText mb={2}>
        Are you sure you want to delete <span style={{ fontWeight: '700', color: 'var(--color-primary)' }}>{selectedCustomer.fullname}?</span>
      </MimaText>

      <div className='modal__beside'>
        <MimaButton
          title={'Yes'}
          width={18}
          onClick={() => onDelete(selectedCustomer._id)}
          loading={loading}
        />

        <MimaButton
          title={'Cancel'}
          width={18}
          buttonColor={'grey'}
          onClick={() => closeModal()}
        />
      </div>
		</Modal>
	);
};

export default DeleteCustomer;